import ErrorPageLayout from 'pages/Error/ErrorPageLayout';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import image from './images/session-expired.svg';

const SessionExpired = () => {
    const history = useHistory();
    const { t } = useTranslation();

    const handleReauthorize = () => {
        return history.push('/login');
    };

    return (
        <ErrorPageLayout
            action={{
                label: t('common:errors.reauthorize', 'Reauthorize'),
                onClick: handleReauthorize,
            }}
            description={t(
                'common:errors.session-expired-description',
                'Your session has expired.\nPlease log back in to continue using TimelyGrader.'
            )}
            image={image}
            imageAlt={t('common:errors.session-expired-illustration', 'Sleeping Hugo illustration')}
            imageHeight={150}
            imageWidth={298}
            title={t('common:errors.session-expired-title', 'Session Expired')}
        />
    );
};

export default SessionExpired;
